import { Capacitor } from '@capacitor/core';
import { useVoiceRecordWeb } from './useVoiceRecordWeb';
import { useVoiceRecordNative } from './useVoiceRecordNative';

export interface UseVoiceRecordOptions {
  onTranscription: (text: string, fileId?: string) => void;
  onError?: (message: string) => void;
  onDictationAttempted?: (opts: { permissionRequested: boolean; permissionGranted: boolean }) => void;
}

export interface UseVoiceRecordReturn {
  isRecording: boolean;
  isTranscribing: boolean;
  toggleRecording: () => void;
  stopRecording: (cancel?: boolean) => void;
}

const isNative = Capacitor.isNativePlatform();

export const useVoiceRecord: (options: UseVoiceRecordOptions) => UseVoiceRecordReturn = isNative
  ? useVoiceRecordNative
  : useVoiceRecordWeb;
